import { filterActiveInvoices } from './invoiceVisibility';

const toNumber = (value) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const sumActiveInvoiceTotal = (invoices = []) =>
  filterActiveInvoices(invoices).reduce((sum, invoice) => sum + toNumber(invoice?.amount), 0);

export const resolveRemainingInvoiceableAmount = ({
  balanceStatus = null,
  salesOrderTotal = 0,
  activeInvoiceTotal = 0,
} = {}) => {
  if (balanceStatus?.uninvoicedAdditionalBalance != null) {
    return Math.max(0, toNumber(balanceStatus.uninvoicedAdditionalBalance));
  }

  return Math.max(0, toNumber(salesOrderTotal) - toNumber(activeInvoiceTotal));
};
